import dayjs from "dayjs";
import moment from "moment";

export const DATE_FORMAT = {
  DD_MM_YYYY: "DD-MM-YYYY",
  D_MMM_YYYY: "D MMM, YYYY",
  YYYY_MM_DD: "YYYY-MM-DD",
  DD_MMM_YYYY: "DD MMM YYYY",
  DD_SLASH_MM_SLASH_YYYY: "DD/MM/YYYY",
  D_MMMM_YYYY: "D MMMM, YYYY",
};

export const formattedDateWithDay = (dateString) => {
  const dateObj = new Date(dateString);

  const date = dayjs(dateObj).format(DATE_FORMAT.DD_MMM_YYYY);
  const dow = dateObj.toLocaleString("default", { weekday: "short" });

  return `${date} (${dow})`; // "15 Aug 2025 (Fri)"
};

export const sample_schools_adverts = [
  {
    bg_color: "rgba(32, 62, 53, 1)",
    logo_link: "assets/images/pamushana.png",
    school_name: "Pamushana University",
    heading_color: "rgba(199, 230, 196, 1)",
    phone_number: "+263810910939",
    avatar_pic_link: "assets/images/avatar1.png",
  },
  {
    bg_color: "rgba(53, 89, 167, 1)",
    logo_link: "assets/images/langham.png",
    school_name: "Langham University",
    heading_color: "rgba(123, 226, 249, 1)",
    phone_number: "+2638001002003",
    avatar_pic_link: "assets/images/avatar1.png",
  },
];

export const institutionType = [
  {
    label: "BOARDING",
    value: "BOARDING",
  },
  {
    label: "DAY",
    value: "DAY",
  },
  {
    label: "DAY/BOARDING",
    value: "DAY/BOARDING",
  },
];

export const curriculumType = [
  {
    label: "Cambridge",
    value: "Cambridge",
  },
  {
    label: "ZIMSEC",
    value: "ZIMSEC",
  },
  {
    label: "Others",
    value: "Others",
  },
];

export const ownershipType = [
  {
    label: "GOVERNMENT",
    value: "GOVERNMENT",
  },
  {
    label: "PRIVATE",
    value: "PRIVATE",
  },
];

export const schoolType = [
  {
    label: "PRIMARY",
    value: "PRIMARY",
  },
  {
    label: "SECONDARY",
    value: "SECONDARY",
  },
];

export const ownershipStatusType = [
  "Association of trust schools",
  "Government schools",
  "Private schools",
  "Church schools",
  "Council schools",
];

export const RELATIONSHIP_OPTIONS = [
  { label: "Mother", value: "Mother" },
  { label: "Father", value: "Father" },
  { label: "Step-Mother", value: "Step-Mother" },
  { label: "Step-Father", value: "Step-Father" },
  { label: "Guardian", value: "Guardian" },
  { label: "Adoptive Mother", value: "Adoptive Mother" },
  { label: "Adoptive Father", value: "Adoptive Father" },
  { label: "Uncle", value: "Uncle" },
  { label: "Aunt", value: "Aunt" },
  { label: "Grandmother", value: "Grandmother" },
  { label: "Grandfather", value: "Grandfather" },
  { label: "Legal Guardian", value: "Legal Guardian" },
  { label: "Foster Mother", value: "Foster Mother" },
  { label: "Foster Father", value: "Foster Father" },
  { label: "Other", value: "Other" },
];

export const genderOptions = [
  {
    label: "BOYS",
    value: "BOYS",
  },
  {
    label: "GIRLS",
    value: "GIRLS",
  },
  {
    label: "MIXED",
    value: "MIXED",
  },
];

export const religionsList = [
  { label: "CHRISTIANITY", value: "CHRISTIANITY" },
  { label: "ISLAM", value: "ISLAM" },
  { label: "HINDUISM", value: "HINDUISM" },
  { label: "BUDDHISM", value: "BUDDHISM" },
  { label: "JUDAISM", value: "JUDAISM" },
  { label: "SIKHISM", value: "SIKHISM" },
  { label: "BAHA'I", value: "BAHA'I" },
  { label: "JAINISM", value: "JAINISM" },
  { label: "SHINTO", value: "SHINTO" },
  { label: "TAOISM", value: "TAOISM" },
  {
    label: "AFRICAN TRADITIONAL RELIGION",
    value: "AFRICAN TRADITIONAL RELIGION",
  },
  { label: "OTHER", value: "OTHER" },
  { label: "NONE", value: "NONE" },
];

export const gendersList = [
  {
    label: "MALE",
    value: "MALE",
  },
  {
    label: "FEMALE",
    value: "FEMALE",
  },
];

export const holidayTypeList = [
  {
    label: "Public",
    value: "Public",
  },
  {
    label: "National",
    value: "National",
  },
  {
    label: "Religious",
    value: "Religious",
  },
  {
    label: "School Event",
    value: "School Event",
  },
  {
    label: "Teacher",
    value: "Teacher",
  },
  {
    label: "Student",
    value: "Student",
  },
];

export const leaveTypeList = [
  {
    label: "All Leaves",
    value: "All Leaves",
  },
  {
    label: "Approved",
    value: "Approved",
  },
  {
    label: "Rejected",
    value: "Rejected",
  },
  {
    label: "Action Required",
    value: "Pending",
  },
];

export const filterLeaveByDate = [
  {
    label: "Latest Date",
    value: "desc",
  },
  {
    label: "Oldest",
    value: "asc",
  },
];

export const maritalStatusList = [
  {
    label: "SINGLE",
    value: "SINGLE",
  },
  {
    label: "MARRIED",
    value: "MARRIED",
  },
  {
    label: "SEPARATED",
    value: "SEPARATED",
  },
  {
    label: "DIVORCED",
    value: "DIVORCED",
  },
];

export const staffRolesList = [
  {
    label: "Teacher",
    value: "Teacher",
  },
  {
    label: "Admin",
    value: "Admin",
  },
  {
    label: "Principal",
    value: "Principal",
  },
  {
    label: "Ancillary",
    value: "Ancillary",
  },
];

export const defaultLatLng = {
  lat: -19.0,
  lng: 29.75,
};

export const CLASS_WITH_SECTION = [
  { label: "A", value: "A" },
  { label: "B", value: "B" },
  { label: "C", value: "C" },
];

export const productDemoRequestTypes = [
  { label: "Pending", value: "PENDING", color: "#1999E4" },
  { label: "In Progress", value: "INPROGRESS", color: "#F0AC2F" },
  { label: "Completed", value: "COMPLETED", color: "#3BB44B" },
  { label: "Rejected", value: "REJECTED", color: "#FF0000" },
];

export const cardColorArr = [
  {
    color: "rgba(49, 175, 66, 1)",
    background: "rgba(41, 188, 61, 0.1)",
    border: "rgba(155, 219, 163, 1)",
  },
  {
    color: "rgba(54, 90, 198, 1)",
    background: "rgba(228, 249, 255, 1)",
    border: "rgba(150, 168, 238, 1)",
  },
  {
    color: "rgba(230, 157, 20, 1)",
    background: "rgba(255, 248, 216, 1)",
    border: "rgba(225, 189, 123, 1)",
  },
  {
    color: "rgba(24, 175, 235, 1)",
    background: "rgba(229, 255, 255, 1)",
    border: "rgba(104, 194, 230, 1)",
  },
  {
    color: "rgba(170, 83, 246, 1)",
    background: "rgba(245, 234, 255, 1)",
    border: "rgba(213, 171, 250, 1)",
  },
  {
    color: "rgba(11, 195, 199, 1)",
    background: "rgba(234, 253, 253, 1)",
    border: "rgba(172, 221, 222, 1)",
  },
];

export const COLOR_CODE = [
  "#31AF42",
  "#365AC6",
  "#E69D14",
  "#18AFEB",
  "#AA53F6",
  "#0BC3C7",
];

export const YES_NO_QUESTIONS = [
  {
    value: "yes",
    label: "Yes",
  },
  {
    value: "no",
    label: "No",
  },
];

export const STUDENT_ACTIVITY = [
  {
    label: "Armenia",
    value: "breakfast",
    reason: "for Football",
  },
  {
    label: "Sunrise",
    value: "lunch",
    reason: "For Music",
  },
];

export const LUNCH_TIME = [
  {
    label: "Breakfast",
    value: "breakfast",
  },
  {
    label: "Lunch",
    value: "lunch",
  },
  {
    label: "Dinner",
    value: "dinner",
  },
];

export const TITLES = [
  { label: "Mr", value: "Mr" },
  { label: "Mrs", value: "Mrs" },
  { label: "Miss", value: "Miss" },
  { label: "Dr", value: "Dr" },
  { label: "Professor", value: "Professor" },
];

export const PAGE_LIMIT = 10;

export const dayToNumber = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export function generateTimeSlots(
  start = "07:00",
  end = "18:00",
  intervalMinutes = 30
) {
  const formatLabel = "h:mm A"; // e.g., "2:00 PM"
  const formatValue = "HH:mm:ss"; // e.g., "14:00:00"
  const timeSlots = [];

  let current = moment(start, "HH:mm");
  const endTime = moment(end, "HH:mm");

  while (current <= endTime) {
    timeSlots.push({
      label: current.format(formatLabel),
      value: current.format(formatValue),
    });
    current.add(intervalMinutes, "minutes");
  }

  return timeSlots;
}

export const DEFAULT_IMAGE = "/assets/images/default-logo.jpg";
export const DEFAULT_PROFILE_IMAGE = `/assets/images/default-profile.jpg`;

export const ROOM_TYPES = [
  { label: "Classroom", value: "Classroom" },
  { label: "Laboratory", value: "Laboratory" },
  { label: "Library", value: "Library" },
  { label: "Staff Room", value: "Staff Room" },
  { label: "Principal's Office", value: "Principal's Office" },
  { label: "Vice Principal's Office", value: "Vice Principal's Office" },
  { label: "Conference Room", value: "Conference Room" },
  { label: "Computer Lab", value: "Computer Lab" },
  { label: "Music Room", value: "Music Room" },
  { label: "Art Room", value: "Art Room" },
  { label: "Medical Room", value: "Medical Room" },
  { label: "Cafeteria", value: "Cafeteria" },
  { label: "Auditorium", value: "Auditorium" },
  { label: "Sports Room", value: "Sports Room" },
  { label: "Storage Room", value: "Storage Room" },
  { label: "Exam Room", value: "Exam Room" },
  { label: "Play Area", value: "Play Area" },
  { label: "Reception", value: "Reception" },
  { label: "Counselor's Office", value: "Counselor's Office" },
];

export const sampleStudentLink =
  "https://eschools-document.s3.us-east-1.amazonaws.com/sample_students.xlsx";

export const sampleTeacherLink =
  "https://eschools-document.s3.us-east-1.amazonaws.com/sample_teachers.xlsx";

export const sampleTimetableLink =
  "https://eschools-document.s3.us-east-1.amazonaws.com/sample_timetable.csv";

export const sampleStudentMixedLink =
  "https://eschools-document.s3.us-east-1.amazonaws.com/sample_students_mixed.xlsx";

export const REPORT_CARD_ERROR = [
  "No marks found for this exam",
  "Student Exam not published yet, visit again later or contact admin",
  "No published assessments found for this student and term",
  "No ECD assessments found for this student in the specified term"
];

export const MAX_FILES = 5;
export const MAX_TOTAL_SIZE = 10 * 1024 * 1024; // 10 MB

export const AUDIENCE_LIST = [
  {
    label: "Select All",
    value: "selectAll",
  },
  {
    label: "Teacher",
    value: "teacher",
  },
  {
    label: "Student",
    value: "student",
  },
  {
    label: "Parent",
    value: "parent",
  }
];

export const COMMUNICATION_CHANNEL = [
  {
    label: "Select All",
    value: "selectAll",
  },
  {
    label: "SMS",
    value: "sms",
  },
  {
    label: "Email",
    value: "email",
  },
];

export const PUBLISHING_SCHEDULE = [
  {
    label: "Publish Now",
    value: "now",
  },
  {
    label: "Schedule for Later",
    value: "later",
  }
];

export const STUDENT_INSTITUTION_TYPE = [
  {
    label: "BOARDING",
    value: "BOARDING",
  },
  {
    label: "DAY",
    value: "DAY",
  },
];

export const PRIVILEGE_TYPE = [
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Accounting",
    value: "account",
  },
];

export const PROMOTION_RULES = [
  {
    label: "Promote into respective classes",
    value: "auto"
  },
  {
    label: "Using student positions in ranking",
    value: "batch-with-ranking"
  },
  {
    label: "Use threshold (avg of selected subjects)",
    value: "batch-with-subject-threshold"
  },
];

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;